import createEnum from "@/helpers/createEnum";

export const LOCATION = createEnum(["MAC_IN_USE", "INVALID_MAC", "UNKNOWN"]);
export const INFO = createEnum(["CANNOT_GET_TOKEN"]);
export const AUTH = createEnum(["NOT_LOGGED_IN"]);
export const HUBS = createEnum(["NO_AVAILABLE_HUBS"]);
